import z from "zod/v4";
import { makeEnum } from "@libs/basic/makeEnum.js";

const values = ["Ostrava", "Olomouc"] as const;

export const branchSchema = z.enum(values);

export const Branch = makeEnum(values);
export type Branch = z.infer<typeof branchSchema>;
